import { Button, HStack, useToast, VStack, Text, Checkbox, Box, Collapse, Flex, Select, Input } from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import { ru } from "date-fns/locale";
import ModalSelectYears from "../modal_select_years";
import ModalSelectManagers from "../modal_select_managers";
import SelectCounteragentPotential from "./select_counteragent_potential";
import SelectStatusDeal from "../select_status_deal";
import SelectSection from "../select_section";
import SelectAccountNumber from "../orders_page/select_account_number";
import { observer } from "mobx-react-lite";
import baseUrl from "../../vars";
import { authFetch } from "../../auth/auth";
import { useStores } from "../../store/store_context";
import { useEffect, useState, useRef } from "react";
import GroupByPotential from "../group_by_potential";
import IsReturnAndPaid from "./is_return_and_paid";
import ModalSelectStaffYears from "../modal_select_staff_years";
import SelectBackup from "../select_backups";
import SelectBind from "../select_bind";
import ModalSelectCompanies from "./modal_select_companies";
import SelectLeads from "./select_leads";
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  subMonths,
  subYears,
  startOfDay,
  endOfDay
} from "date-fns";

const FiltersGrid = observer(({ renderButtons }) => {
  const { pageStore } = useStores();

  const [isLoading, setIsLoading] = useState(false);

  const toast = useToast();

  const [requestTime, setRequestTime] = useState(0);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const timerRef = useRef(null);

  const handleCancel = () => {
    if (pageStore.abortControllerRef) {
      pageStore.abortControllerRef.abort();
      console.log('Нажата кнопка отмены');
    }
  };

  const startTimer = () => {
    setIsTimerActive(true);
    const startTime = Date.now();
    setRequestTime(0);
    pageStore.setRequestTime(0);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setRequestTime((Date.now() - startTime) / 1000);
      pageStore.setRequestTime((Date.now() - startTime) / 1000);
    }, 50);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setIsTimerActive(false);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);


  console.log(pageStore.selected_managers);

  useEffect(() => {
    pageStore.resetPotentialFilters();
  }, []);

  const getPeriodDates = (periodType) => {
    const now = new Date();
    switch (periodType) {
      case 'week':
        return {
          start: startOfWeek(now, { locale: ru }),
          end: endOfWeek(now, { locale: ru })
        };
      case 'month':
        return {
          start: startOfMonth(now),
          end: endOfMonth(now)
        };
      case 'quarter':
        return {
          start: startOfQuarter(now),
          end: endOfQuarter(now)
        };
      case 'halfYear':
        return {
          start: startOfMonth(subMonths(now, 6)),
          end: endOfMonth(now)
        };
      case 'year':
        return {
          start: startOfYear(now),
          end: endOfYear(now)
        };
      case 'pastYear':
        const lastYear = subYears(now, 1);
        return {
          start: startOfYear(lastYear),
          end: endOfYear(lastYear)
        };
      default:
        return { start: null, end: null };
    }
  };

  const getAllPotentials = async () => {
    setIsLoading(true);
    startTimer();
    pageStore.abortControllerRef = new AbortController();
    const { signal } = pageStore.abortControllerRef;
    pageStore.setLoading(true)
    pageStore.clearDataPotentials([]);
    let page = 0;
    const count = 500;
    let total = 0;

    try {
      const query = new URLSearchParams();

      if (pageStore.selected_years && pageStore.selected_years != "") {
        pageStore.selected_years.forEach((year) => {
          query.append("years", year);
        });
      }

      if (pageStore.selected_managers?.length > 0) {
        pageStore.selected_managers?.forEach((manager) => {
          query.append("managers", manager);
        });
      }

      if (pageStore.selected_one_agent_potential != "") {
        query.append("partners", pageStore.selected_one_agent_potential);
      }

      if (pageStore.selected_one_department != "") {
        query.append("departament", pageStore.selected_one_department);
      }

      if (pageStore.status_deal != "all") {
        query.append("status", pageStore.status_deal);
      }

      if (pageStore.selected_one_account_number != "") {
        query.append("acc_num", pageStore.selected_one_account_number);
      }

      if (pageStore.select_one_company != "") {
        query.append("PromotionCompanies", pageStore.select_one_company);
      }

      if (pageStore.selected_type_leads != "") {
        query.append("leadType", pageStore.selected_type_leads);
      }

      if (pageStore.selected_view && (pageStore.selected_view.isReturn || pageStore.selected_view.isNotReturn)) {
        if (pageStore.selected_view.isReturn && !pageStore.selected_view.isNotReturn) query.append("isReturn", 1);
        else if (!pageStore.selected_view.isReturn && pageStore.selected_view.isNotReturn) query.append("isReturn", 0);
        else query.append("isReturn", 3)
      }

      if (pageStore.potential_period_deal && pageStore.potential_period_deal != "none" && pageStore.potential_period_deal != "custom") {
        const { start, end } = getPeriodDates(pageStore.potential_period_deal);
        query.append("start_deal_date", start.toISOString());
        query.append("end_deal_date", end.toISOString());
      } 
      
      if (pageStore.potential_period_deal === "custom" && pageStore.potential_period_deal_start) {
        query.append("start_deal_date", new Date(pageStore.potential_period_deal_start).toISOString());
      }

      if (pageStore.potential_period_deal === "custom" && pageStore.potential_period_deal_end) {
        query.append("end_deal_date", new Date(pageStore.potential_period_deal_end).toISOString());
      }

        if (pageStore.selected_staff_years) {
          query.append("staff_year", pageStore.selected_staff_years)
        }

      query.append("page", page);
      query.append("count", count);

      const response = await authFetch(`${baseUrl}/api/potential?${query}`, {
        method: "GET",
        signal: signal,
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${pageStore.token}`,
          "X-Database": pageStore.select_backup != "" ? "temp" : "main"
        },
      });

      const result = await response.json();

      const data = result?.data || [];
      if (page == 0) total = result?.total || 0;

      pageStore.addDataPotential(data);
    } catch (err) {
      toast({
        title: "Ошибка загрузки потенциалов",
        description: err.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      pageStore.AbortControllerRef = null;
      pageStore.setLoading(false)
      setIsLoading(false);
      stopTimer();
    }
  };

  const buttons = (
    <>
      <Button
        isLoading={isLoading}
        onClick={async () => await getAllPotentials()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сформировать
      </Button>
      <Button
        onClick={() => pageStore.resetPotentialFilters()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
        mr={3}
      >
        Сбросить фильтры
      </Button>
      <Button
        onClick={() => handleCancel()}
        bg="#333"
        color="white"
        w={{ base: "100%", md: "15vw" }}
        _hover={{
          background: "#444",
        }}
      >
        Отменить апрос
      </Button>
    </>
  )

  return (
    <>
      <Box position="relative" w="100%">
        <VStack width="100%" align="center" px={{ base: "10px", md: "20px" }}>
          <Collapse in={pageStore.open_filter} animateOpacity style={{ width: '100%' }}>
            <Box w="100%">
              <VStack w={"100%"} gap={{ base: "20px", md: "15px" }}>

                {/* Первый ряд: Основные фильтры */}
                <Flex
                  width="100%"
                  direction={{ base: "column", lg: "row" }} // В колонку на мобилках, в ряд на больших экранах
                  align={{ base: "stretch", lg: "flex-start" }} // Растягиваем на мобилках, выравниваем по низу на ПК
                  gap={4}
                  wrap="wrap"
                  justify="center"
                >
                  <VStack align={{ base: "center", lg: "start" }}>
                    <Text fontWeight={"600"} fontSize={"16px"} color={"white"}>
                      Выберите годы:
                    </Text>
                    <ModalSelectYears />
                  </VStack>

                  <VStack align="start">
                    <Text
                      width={{ base: "100%", lg: "300px" }} // На мобилках не ограничиваем ширину текста
                      fontWeight={"600"}
                      fontSize={"12px"}
                      color={"white"}
                    >
                      Менеджеры:
                    </Text>
                    <ModalSelectManagers />
                  </VStack>

                  <VStack align="start">
                    <Text fontWeight={"600"} fontSize={"12px"} color={"white"}>
                      Группировка:
                    </Text>
                    <GroupByPotential />
                  </VStack>

                  <ModalSelectStaffYears />
                  <VStack align="stretch" spacing={2} w={{ base: "100%", sm: "auto" }}>
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content" // Дополнительно указываем высоту по контенту
                    >
                      <Checkbox
                        colorScheme="green"
                        isChecked={pageStore.workers}
                        onChange={(e) => pageStore.setWorkers(e.target.checked)}
                        size={{ base: "sm", md: "md" }}
                      >
                        Работающие
                      </Checkbox>
                    </VStack>
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content"
                    >
                      <Text>Лиды:</Text>
                      <SelectLeads />
                    </VStack>
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content"
                    >
                      <Text>Рекламные кампании:</Text>
                      <ModalSelectCompanies />
                    </VStack>
                    <VStack
                      align="start"
                      spacing={2}
                      bg="#333"
                      p={3}
                      borderRadius="10px"
                      color="#EEEEEE"
                      w={{ base: "100%", sm: "auto" }}
                      h="fit-content"
                    >
                      <Text fontSize={"20px"}>Период сделки</Text>
                      <Select
                        value={pageStore.potential_period_deal}
                        onChange={(e) => {
                          pageStore.setPotentialPeriodDeal(e.target.value);
                        }}
                      >
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="none">Без фильтра(все)</option>
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="month">Текущий месяц</option>
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="quarter">Текущий квартал</option>
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="halfYear">Текущее полугодие</option>
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="year">Текущий год</option>
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="pastYear">Прошлый год</option>
                        <option style={{ background: "#0C0C0C", color: "#EEEEEE" }} value="custom">Произвольный период</option>
                      </Select>
                    </VStack>
                    {pageStore.potential_period_deal === 'custom' && (
                      <VStack>
                        <Text fontSize={"20px"}>Дата открытия сделки</Text>
                        <HStack>
                          <DatePicker
                            selected={pageStore.potential_period_deal_start ? new Date(pageStore.potential_period_deal_start) : ''}
                            onChange={(date) => pageStore.setPotentialPeriodDealStart(date)}
                            dateFormat="dd.MM.yyyy"
                            locale={ru}
                            placeholderText="выберете день начала"
                            popperContainer={({ children }) => (
                              <div style={{ zIndex: 9999, position: 'relative' }}>{children}</div>
                            )}
                            customInput={
                              <Input
                                style={{
                                  border: "none",
                                  background: "#333",
                                  color: "#EEEEEE",
                                  borderRadius: "10px",
                                  fontWeight: 600,
                                }}
                              />
                            }
                          />

                          <DatePicker
                            selected={pageStore.potential_period_deal_end ? new Date(pageStore.potential_period_deal_end) : ''}
                            onChange={(date) => pageStore.setPotentialPeriodDealEnd(date)}
                            dateFormat="dd.MM.yyyy"
                            locale={ru}
                            placeholderText="выберете день окончания"
                            popperContainer={({ children }) => (
                              <div style={{ zIndex: 9999, position: 'relative' }}>{children}</div>
                            )}
                            customInput={
                              <Input
                                style={{
                                  border: "none",
                                  background: "#333",
                                  color: "#EEEEEE",
                                  borderRadius: "10px",
                                  fontWeight: 600,
                                }}
                              />
                            }
                          />
                        </HStack>
                      </VStack>
                    )}
                  </VStack>

                  <Flex gap={2} wrap="wrap" justify="center">
                    <SelectBackup />
                    <SelectBind report_name={"potential"} />
                  </Flex>
                </Flex>

                {/* Второй ряд: Дополнительные параметры */}
                <Flex
                  width="100%"
                  direction={{ base: "column", md: "row" }}
                  wrap="wrap"
                  justify="center"
                  gap={3}
                >
                  <IsReturnAndPaid />
                  <SelectStatusDeal />
                  <SelectCounteragentPotential />
                  <SelectSection />
                </Flex>

              </VStack>
            </Box>
          </Collapse>
        </VStack>
      </Box>
      <Collapse in={pageStore.open_filter} animateOpacity>
        {renderButtons ? renderButtons(buttons) : buttons}
      </Collapse>

    </>
  );
});

export default FiltersGrid;
